import { Component, input, Input } from '@angular/core';


@Component({
    selector: 'soft-default-page-header-content',
    imports: [],
    templateUrl: './default-page-header-content.component.html',
    styleUrl: './default-page-header-content.component.css'
})
export class DefaultPageHeaderContentComponent {
  overline = input<string | null | undefined>(undefined);
  title= input<string | null | undefined>(undefined);
  subtitle= input<string | null | undefined>(undefined);
}
